////////LIBRARY/////////
import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { cloneDeep, isEqual, map, reduce, isUndefined, reject, find, isEmpty } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import Button from '../Ui/Buttons'
import theme from '../../theme/theme'
import ToggleFilters from '../Ui/ToggleFilters'
import { PageTitle, PageWrapperActions, PageWrapperActionValidate, ButtonWrapper, InputLogin, ErrorInputMsg } from '../../theme/GlobalCss'
import ImgButton from '../Ui/ImgButton'
import UseDatePicker from '../../hooks/UseDatePicker'
import { campaignPriceActionCreators } from '../../store/actions'
import PriceCampaignCreationSecondLine from './PriceCampaignCreationSecondLine'
import { selectIdsUser } from '../../store/selectors/user'
import Modals from '../Modals'
import Table from '../Table'
/////////ASSETS/////////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import campaignSettingIcon from '../../assets/icones/global/campaign-setting.svg'
import Calendar from '../../assets/icones/global/calendar.svg'

/////////STYLED/////////
const PriceCampaignWrapper = styled.div`
	position: relative;
`
const PriceCampaignHeader = styled.div`
	display: flex;
	& > :first-child {
		margin: 0px auto 0px 0px;
	}
	& > * {
		top: 0px !important;
	}
	& > :last-child {
		margin-left: 25px;
	}
	margin-bottom: 15px;
`
const ButtonSize = styled.div`
	display: flex;
	height: 32px;
`
const PriceCampaignFilters = styled.div`
	position: relative;
	padding-right: 17px;
	& > * {
		margin: 0px 7px;
	}
	& > :first-child img {
		max-height: 24px;
		margin: 0px 10px 0px 0px;
	}
	display: flex;
	flex-direction: row;
`
const PriceCampaignContent = styled.div`
	overflow: auto;
	padding: 0px 30px;
	background-color: #f1f1f1;
`
const PriceCampaignInputs = styled.div`
	display: flex;
	& > * {
		margin: 0px 7px;
	}
`
const PriceCampaignInputDate = styled.div`
	display: flex;
	& p {
		margin: 0;
	}
`
const PriceCampaignInputName = styled.div`
	display: flex;
	& p {
		margin: 0px 15px 0px 0px;
	}
`
const DatePickerCampaignIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	margin: 0px 8px 0px 15px;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const SpanDelete = styled.span`
	cursor: pointer;
`
const ModalText = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
`
const ModalListKiosksName = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 10px;
	overflow: auto;
	background-color: #f5f6fa;
	margin: 20px 0;
`
/////////STYLED/////////

const PriceCampaignHandlerCreate = (props) => {
	const [data, setData] = useState({})

	const [stateDefaultValues, setStateDefaultValues] = useState({
		campaignName: '',
	})
	const [immediateChangePrice, setImmediateChangePrice] = useState(true)

	const [widthTaxes, setWidthTaxes] = useState(props.widthTaxes)

	const [sendConfirm, setSendConfirm] = useState(false)

	const campaignActions = bindActionCreators(campaignPriceActionCreators, useDispatch())

	const { translations, userIds, campaign } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			userIds: selectIdsUser(state),
			campaign: state.campaignPrice.campaign,
		}),
		shallowEqual
	)

	const { register, handleSubmit, errors, setValue, getValues } = useForm({
		mode: 'onChange',
		defaultValues: stateDefaultValues,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteLine = (id) => {
		const dataCP = cloneDeep(data)
		if (dataCP.priceCampaignLines.length === 1) return // guard to delete last line
		dataCP.priceCampaignLines = reject(dataCP.priceCampaignLines, { idItem: id })
		setData(dataCP)
	}

	const [dateCampaignShowModal, dateCampaignOpenDateModalHandler, dateCampaignRenderModal, dateCampaignStateDate, setStartDate] = UseDatePicker({
		defaultDateStart: data?.dateStart ? moment(data.dateStart).toDate() : new Date(),
		noInterval: true,
		noPastDate: true,
		ifCancel: true,
		insideModal: true,
	})

	const updateMode = props.updateMode || false

	const [columns, setColumns] = useState()

	const config = {
		name: '',
		fixedColumnSelection: true,
		isUpdateCampaign: updateMode,
		isCampaign: true,
		campaignValues: {
			campaignComponent: PriceCampaignCreationSecondLine,
		},
		noWindowing: true,
	}

	const handleWithTTC = () => {
		setWidthTaxes((prevState) => !prevState)
	}

	const onErrors = () => {
		setSendConfirm(false)
	}

	const onSubmit = (submittedData) => {
		const updatedData = cloneDeep(submittedData)

		updatedData.priceValue = map(data.priceCampaignLines, (elem) => ({
			...submittedData.priceValue[elem.lineNumber],
			idItem: elem.idItem,
			idKiosk: elem.idKiosk,
		}))

		const dateStart = immediateChangePrice ? dateCampaignStateDate.date.startDate : false
		campaignActions.createCampaign(
			{
				campaignName: immediateChangePrice ? new Date() : submittedData.campaignName,
				dateStart: moment(dateCampaignStateDate.date.startDate).toDate(),
				toApplyNow: !!dateStart,
				withTTC: widthTaxes,
				idDistributor: data.idDistributor,
				itemsPrices: reduce(
					updatedData.priceValue,
					(result, elem) => {
						!isUndefined(elem) &&
							elem.idItem &&
							result.push({
								idItem: Number(elem.idItem),
								idKiosk: elem.idKiosk,
								standardPrice: Number(elem.actualStandardPrice),
								depositPrice: !isUndefined(elem.actualDepositPrice) ? Number(elem.actualDepositPrice) : null,
							})
						return result
					},
					[]
				),
				kioskstoUpdate: userIds.kiosksPoolSelectedIds,
			},
			props.target
		)
		setSendConfirm(false)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!props.successCreateCampaign) return
		props.closeModalHandler()
	}, [props.successCreateCampaign])

	useEffect(() => {
		// Set current date by default
		setStartDate(moment().toDate())

		return function cleanUp() {
			setStateDefaultValues({ campaignName: '' })
			setImmediateChangePrice(true)
			setSendConfirm(false)
			setData({})
			campaignActions.resetCampaign()
		}
	}, [])

	// Handling immediate price change or scheduled one
	useEffect(() => {
		if (isUndefined(data)) return
		setImmediateChangePrice(!data.dateStart)
	}, [data])

	useEffect(() => {
		if (isUndefined(data)) return

		if (data?.label?.length > 0) {
			setValue('campaignName', data?.label)
			setStateDefaultValues(getValues())
		}

		setColumns([
			{
				titleColumnCampaign: true,
				widthTaxes: widthTaxes,
				errors: errors,
				callErrors: props?.campaignErrors,
				currency: data?.currency,
				register: register,
				component: () => <div>Valeurs actuelles</div>,
			},
			{ dataHook: 'kioskCode', headerName: translations['page__promotionManagement__tableHeader_expand_kioskCode'], sortable: true },
			{ dataHook: 'store', headerName: translations['page__promotionManagement__tableHeader_expand_store'], sortable: true },
			{
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_family'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'itemBrand.label',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_brand'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'label',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_product'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: widthTaxes ? 'actualStandardPriceTTC' : 'actualStandardPriceHT',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemPrice'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: widthTaxes ? 'actualStandardPriceHT' : 'actualStandardPriceTTC',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_convert'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'standardPriceVATRate',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemVAT'],
				sortable: true,
				isAuthorize: true,
				component: (_props) => `${_props?.row?.standardPriceVATRate}%`,
			},
			{
				dataHook: widthTaxes ? 'actualDepositPriceTTC' : 'actualDepositPriceHT',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositPrice'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'depositPriceVATRate',
				headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositVAT'],
				sortable: true,
				isAuthorize: true,
				component: (_props) => `${_props?.row?.depositPriceVATRate}%`,
			},
			{ action: true, component: (_props) => <SpanDelete onClick={() => handleDeleteLine(_props?.row?.idItem)}>X</SpanDelete> },
		])
	}, [data, widthTaxes])

	useEffect(() => {
		if (isEmpty(campaign)) return // guard to set row on reset campaign
		setData({
			kiosks: campaign.Kiosks,
			priceCampaignLines: campaign.Items,
			currency: campaign.currency,
			label: '',
			dateStart: null,
			idDistributor:
				find(props.filters.filtersSelection?.distributors?.filterElements, { active: true }).id ||
				props.filters.filtersSelection?.distributors?.filterElements[0].id,
		})
	}, [campaign])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Modals closeModalHandler={props.closeModalHandler} showModal={props.showModal} minWidth={1200}>
			<Modals
				showModal={sendConfirm}
				closeModalHandler={() => setSendConfirm(false)}
				title={translations['modal__pricesManagement__pricesCampaign_validation_title']}
				level={'error'}
				maxWidth={555}
				insideModalResponse={true}
				insideModal
				icon={true}
			>
				<ModalText>
					{!isUndefined(data?.kiosks) &&
						`${translations['modal__pricesManagement__pricesCampaign_validation_message_start']} 
							${data?.kiosks.length} 
							${translations['modal__pricesManagement__pricesCampaign_validation_message_end']}`}
				</ModalText>
				<ModalListKiosksName>{!isUndefined(data) && map(data.kiosks, (elem, id) => <p key={id}>{elem.kioskName}</p>)}</ModalListKiosksName>

				<ButtonWrapper>
					<Button
						bgColor={theme.colors.error}
						actionHandler={() => setSendConfirm(false)}
						text={translations['common__text__cancel']}
						img={Cancel}
						width={150}
					/>

					<Button
						text={translations['modal__promotionManagement__validation_button_valid']}
						actionHandler={handleSubmit(onSubmit, onErrors)}
						bgColor={theme.colors.validation}
						img={Validation}
						width={270}
						noHash
					/>
				</ButtonWrapper>
			</Modals>
			{dateCampaignRenderModal()}
			<PriceCampaignWrapper>
				<form onSubmit={handleSubmit(onSubmit, onErrors)}>
					<PriceCampaignHeader>
						{immediateChangePrice && <PageTitle>{translations['page__priceManagement__tablePriceCampaign_now_title']}</PageTitle>}
						{(!immediateChangePrice || updateMode) && (
							<PriceCampaignInputs>
								<PriceCampaignInputDate>
									<PageTitle>{translations['modal__pricesManagement__pricesCampaign_creation_date']}</PageTitle>
									<DatePickerCampaignIcon onClick={dateCampaignOpenDateModalHandler} />
									<span>
										{isEqual(dateCampaignStateDate.date.startDate, {})
											? moment(new Date()).format('DD/MM/YYYY HH:mm')
											: moment(dateCampaignStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
									</span>
								</PriceCampaignInputDate>
								<PriceCampaignInputName>
									<PageTitle>{translations['modal__pricesManagement__pricesCampaign_creation_name']}</PageTitle>
									<InputLogin
										name="campaignName"
										type="text"
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 100,
												message: `100 ${translations['common__text__charMax']}`,
											},
										})}
									/>
									{errors.campaignName && <ErrorInputMsg>{errors.campaignName.message}</ErrorInputMsg>}
								</PriceCampaignInputName>
							</PriceCampaignInputs>
						)}

						<Fragment>
							{!updateMode && (
								<PriceCampaignFilters>
									<ButtonSize>
										<Button
											as={'div'}
											img={campaignSettingIcon}
											actionHandler={() => setImmediateChangePrice((prevState) => !prevState)}
											text={
												immediateChangePrice
													? translations['page__priceManagement__button_priceCampaign_schedule']
													: translations['page__priceManagement__buttonpriceCampaign_now']
											}
											bgColor={theme.colors.primary}
										/>
									</ButtonSize>
									<ButtonSize>
										<ToggleFilters
											checked={widthTaxes}
											onChangeHandler={handleWithTTC}
											size={'large'}
											name="withTTC"
											labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
											labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
										/>
									</ButtonSize>
								</PriceCampaignFilters>
							)}
						</Fragment>
						<PageWrapperActions>
							<PageWrapperActionValidate unlocked as={'div'} onClick={() => setSendConfirm(true)} />
							<ImgButton
								img={Cancel}
								action={() => props.closeModalHandler()}
								color={theme.colors.error}
								margin={'5px'}
								hover={theme.colors.hoverError}
							/>
						</PageWrapperActions>
					</PriceCampaignHeader>
					<PriceCampaignContent>
						{translations && !isUndefined(data) && !isUndefined(columns) && (
							<Table inputColumns={columns} inputData={data.priceCampaignLines} inputConfig={config} />
						)}
					</PriceCampaignContent>
				</form>
			</PriceCampaignWrapper>
		</Modals>
	)
}

PriceCampaignHandlerCreate.propTypes = {}
PriceCampaignHandlerCreate.defaultPropTypes = {}

PriceCampaignHandlerCreate.propTypes = {}
PriceCampaignHandlerCreate.defaultPropTypes = {}

export default PriceCampaignHandlerCreate
